import React from 'react';
import { IPageVerticalContentStepperProps } from './PageVerticalContentStepperProps'

import './PageVerticalContentStepperStyles.scss'


const PageVerticalContentStepper = (props: IPageVerticalContentStepperProps) => {

  const { StepOneContentElement, StepTwoContentElement } = props

  return (
    <div className='page-vertical-contents-stepper-outer-wrapper'>
        <span className='page-vertical-contents-stepper-line'/>
        <p id='page-vertical-contents-stepper-number-one'  className='page-vertical-contents-stepper-number'>1</p>
        <p id='page-vertical-contents-stepper-content-one' className='page-vertical-contents-stepper-content'>
         {
            StepOneContentElement()
         }
        </p>
        <p id='page-vertical-contents-stepper-number-two'  className='page-vertical-contents-stepper-number'>2</p>
        <p id='page-vertical-contents-stepper-content-two' className='page-vertical-contents-stepper-content'>
          {
            StepTwoContentElement()
          }
        </p>
    </div>
  )
}


export default PageVerticalContentStepper